import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "toggle", "icon"]

  connect() {
    this.renderIcon(this.inputTarget.type === "text")
  }

  toggle(event) {
    event.preventDefault()

    const showingPassword = this.inputTarget.type === "text"
    this.inputTarget.type = showingPassword ? "password" : "text"
    this.toggleTarget.setAttribute("aria-label", showingPassword ? "Show password" : "Hide password")
    this.renderIcon(!showingPassword)
  }

  renderIcon(showingPassword) {
    this.iconTarget.className = "password-visibility-icon"
    this.iconTarget.innerHTML = showingPassword ? this.eyeSlashSvg() : this.eyeSvg()
  }

  eyeSvg() {
    return '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.12 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0"/></svg>'
  }

  eyeSlashSvg() {
    return '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M13.359 11.238l1.387 1.387l-.707.707l-1.53-1.53A8.8 8.8 0 0 1 8 13.5C3 13.5 0 8 0 8a15.7 15.7 0 0 1 3.109-3.726L1.646 2.811l.708-.707l12 12l-.707.707l-1.288-1.288zM11.297 10.176l-1.442-1.442a2.5 2.5 0 0 1-3.089-3.089L5.324 4.203A13.3 13.3 0 0 0 2.832 5.957A13 13 0 0 0 1.172 8c.058.087.122.183.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.879 12.5 8 12.5a7.8 7.8 0 0 0 3.297-.824M8.5 7.379l.621.62a1.5 1.5 0 0 1-1.122 1.122l-.62-.62a1.5 1.5 0 0 1 1.12-1.122"/><path d="M5.147 3.44l1.24 1.24A3.5 3.5 0 0 1 11.32 9.61l1.254 1.254A13.3 13.3 0 0 0 13.168 10.043A13 13 0 0 0 14.828 8a13 13 0 0 0-1.66-2.043C11.879 4.668 10.121 3.5 8 3.5a7.8 7.8 0 0 0-2.853.56"/></svg>'
  }
}
